import { classes } from '@core/cards/ProductCard/getProductCardCss';

type Props = {
  children: NonNullable<React.ReactNode>;
};

const CardBody = ({ children }: Props) => {
  return <div className={classes.body}>{children}</div>;
};

export default CardBody;
